import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import NoPage from "./components/NoPage";
import LegalDocuments from "./pages/legalDocuments";
import Signature from "./mobile";
import "./App.css";
import "./assets/scss/styles.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='*' element={<NoPage />} />
        <Route exact path='/' element={<Home />} />
        <Route path='/legalDoc' element={<LegalDocuments />} />
        <Route path='/document' element={<Signature />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
